export default __webpack_public_path__ + "static/media/blog-3.f9c0a84d.jpg";